import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { SaleOrderProcessTypeController } from './sale-order-process-type.controller';
import { SaleOrderProcessTypeService } from './sale-order-process-type.service';
import {SaleorderprocessType} from './sale-order-process-type.entity'
import {SaleorderprocessTypeAdapter} from './dto/sale-order-process-type.adapter'
@Module({
  imports: [
    TypeOrmModule.forFeature([SaleorderprocessType]),
  ],

  controllers: [SaleOrderProcessTypeController],
  providers: [SaleOrderProcessTypeService,SaleorderprocessTypeAdapter,ApplicationExceptionHandler],

  exports:[SaleOrderProcessTypeService]
})
export class SaleOrderProcessTypeModule {}
